export const gridSpacing    = 3;
export const drawerWidth    = 250;
export const SERVER_API_URL = process.env.REACT_APP_SERVER_API_URL;
//export const SERVER_API_URL = 'https://configtool.azurefd.net/config/api';
export const issuerUrl      = "https://dev-61837828.okta.com/oauth2/ausid15p8apH2M0GC5d7";
export const oktaClientID   = "0oai9scytrYqsja3p5d7";